
const fuelOptions = [
    { id: "Petrol", label: "Petrol" },
    { id: "Diesel", label: "Diesel" },
    { id: "Electric", label: "Electric" },
    { id: "Hybrid", label: "Hybrid" },
    { id: "LPG", label: "LPG" },
    { id: "CNG", label: "CNG" },
    { id: "Ethanol", label: "Ethanol" },
    { id: "Biodiesel", label: "Biodiesel" },
    { id: "Gasoline", label: "Gasoline" },
    { id: "Other", label: "Other" },
  ];
  
  // API key
  const fuelAPIKey = "fuel"; 
  
  // Label
  const fuelLabel = "Fuel Type"; 
  
  export { fuelOptions, fuelLabel, fuelAPIKey };
  